module.exports = __webpack_public_path__ + "img/8.68a75b7b.png";